(function ($) {

    // adjust color
    // method is overriden. source method located in jqwidgets/jqxchart.core.js
    $.jqx.adjustColor = function(f, e, firstAdjustOpt) {
        if (typeof (f) != "string" || f === "#000000") {
            return "#000000";
        }
        if (f.indexOf("#") == -1) {
            return f;
        }

        // options
        var minLuminance = 0.91;
        var adjustStep = 0.05;


        var firstAdjust = firstAdjustOpt || e;

        // console.log('source color:', f);
        // console.log('source adjust:', e);
        // console.log('first adjust', firstAdjust);

        function getLuminance(rgb, normalized) {
            var div = normalized ? 1 : 255,
                RGB = [rgb.r / div, rgb.g / div, rgb.b / div],
                luminance = {
                    b: 0.0722,
                    g: 0.7152,
                    r: 0.2126
                };

            for (var i = RGB.length; i--;) {
                RGB[i] = RGB[i] <= 0.03928 ? RGB[i] / 12.92 : Math.pow(((RGB[i] + 0.055) / 1.055), 2.4);
            }
            return ((luminance.r * RGB[0]) + (luminance.g * RGB[1]) + (luminance.b * RGB[2]));
        }

        var h = $.jqx.cssToRgb(f);
        var d = $.jqx.rgbToHsl(h);
        d[2] = Math.min(1, d[2] * e);
        d[1] = Math.min(1, d[1] * e * 1.1);
        h = $.jqx.hslToRgb(d);
        var t = "#";
        for (var j = 0; j < 3; j++) {
            var k = Math.round(h[j]);
            k = $.jqx.decToHex(k);
            if (k.toString().length == 1) {
                t += "0";
            }
            t += k;
        }

        if (firstAdjust > 1 && firstAdjust <= 1.8) {
            var eRgb = (function() {
                var eRgbArr = $.jqx.cssToRgb(t);
                return {
                    r: eRgbArr[0],
                    g: eRgbArr[1],
                    b: eRgbArr[2]
                };
            })();

            if ((getLuminance(eRgb) > minLuminance) || (t.toLowerCase() === f.toLowerCase())) {
                // console.log('new color:', t);
                // console.log('luminance is to high:', getLuminance(eRgb));
                // console.log('next adjust step:', e - adjustStep);
                return $.jqx.adjustColor(f, e - adjustStep, firstAdjust);
            }
        }

        // console.log('return:', t.toUpperCase());
        // console.log('\n\n********************\n');
        return t.toUpperCase();
    };

    var calculateTransparentColor = function (foregroundColor, opacity, backgroundColor) {
        backgroundColor = backgroundColor || '#FFFFFF';
        opacity = (opacity || 0.67) * 1.0; // default opacity and make it float
        if (opacity < 0.0 || opacity > 1.0 || !this.COLOR_REGEX.test(foregroundColor) || !this.COLOR_REGEX.test(backgroundColor)) {
            // todo: log invalid input
            return foregroundColor;
        }
        var foregroundRGB = this.colorHexToRGB(foregroundColor);
        var backgroundRGB = this.colorHexToRGB(backgroundColor);
        var finalRed = Math.round(backgroundRGB.r * (1 - opacity) + foregroundRGB.r * opacity);
        var finalGreen = Math.round(backgroundRGB.g * (1 - opacity) + foregroundRGB.g * opacity);
        var finalBlue = Math.round(backgroundRGB.b * (1 - opacity) + foregroundRGB.b * opacity);
        return '#' + this.toHex2(finalRed) + this.toHex2(finalGreen) + this.toHex2(finalBlue);
    }.bind({
        colorHexToRGB: function (htmlColor) {
            var arrRGB = htmlColor.match(this.COLOR_REGEX);
            return { "r": parseInt(arrRGB[1], 16), "g": parseInt(arrRGB[2], 16), "b": parseInt(arrRGB[3], 16) };
        },
        toHex2: function (number) {
            return (256 + number).toString(16).slice(-2);
        },
        COLOR_REGEX: /^#([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
    });

    var clrs = $.extend(true, {}, $.cdh.brandData);

    clrs.ChartFsaAvailableLightColor = calculateTransparentColor(clrs.ChartFsaAvailableColor);
    clrs.ChartFsaSpentLightColor = calculateTransparentColor(clrs.ChartFsaSpentColor);

    clrs.ChartHraAvailableLightColor = calculateTransparentColor(clrs.ChartHraAvailableColor);
    clrs.ChartHraSpentLightColor = calculateTransparentColor(clrs.ChartHraSpentColor);

    clrs.ChartHraDormantAvailableLightColor = calculateTransparentColor(clrs.ChartHraDormantPrimary);
    clrs.ChartHraDormantSpentLightColor = calculateTransparentColor(clrs.ChartHraDormantSecondary);

    clrs.ChartHsaAvailableLightColor = calculateTransparentColor(clrs.ChartHsaAvailableColor);
    clrs.ChartHsaInvestmentLightColor = calculateTransparentColor(clrs.ChartHsaInvestmentColor);

    clrs.ChartYearToDateSpendingRemainingLightColor = calculateTransparentColor(clrs.ChartYearToDateSpendingRemainingColor);
    clrs.ChartYearToDateSpendingReimbursedLightColor = calculateTransparentColor(clrs.ChartYearToDateSpendingReimbursedColor);
    clrs.ChartYearToDateSpendingPaidLightColor = calculateTransparentColor(clrs.ChartYearToDateSpendingPaidColor);

    $.extend(true, $.jqx._jqxChart.prototype.colorSchemes, [
        { name: 'account-balance-donut-hsa', colors: [clrs.ChartHsaInvestmentLightColor, clrs.ChartHsaAvailableLightColor, calculateTransparentColor("#D68127"), clrs.ChartHsaInvestmentColor, clrs.ChartHsaAvailableColor, "#D68127"] },
        { name: 'account-balance-donut-fsa', colors: [clrs.ChartFsaSpentLightColor, clrs.ChartFsaAvailableLightColor, clrs.ChartFsaSpentColor, clrs.ChartFsaAvailableColor] },
        { name: 'account-balance-donut-hra', colors: [clrs.ChartHraSpentLightColor, clrs.ChartHraAvailableLightColor, clrs.ChartHraSpentColor, clrs.ChartHraAvailableColor] },
        { name: 'account-balance-donut-hra-dormant', colors: [clrs.ChartHraDormantSpentLightColor, clrs.ChartHraDormantAvailableLightColor, clrs.ChartHraDormantSecondary, clrs.ChartHraDormantPrimary] },


        { name: 'account-balance-column-hsa', colors: [clrs.ChartHsaAvailableColor, clrs.ChartHsaInvestmentColor] },
        { name: 'account-balance-column-fsa', colors: [clrs.ChartFsaAvailableColor, clrs.ChartFsaSpentColor] },
        { name: 'account-balance-column-hra', colors: [clrs.ChartHraAvailableColor, clrs.ChartHraSpentColor] },
        { name: 'account-balance-column-hra-dormant', colors: [clrs.ChartHraDormantPrimary, clrs.ChartHraDormantSecondary] },

        
        { name: 'account-annual-contribution-fsa', colors: [clrs.ChartFsaContributedSoFarColor, clrs.ChartFsaRemainingToContributeColor] },
        { name: 'account-annual-contribution-hra', colors: [clrs.ChartHraContributedSoFarColor, clrs.ChartHraRemainingToContributeColor] },

        { name: 'contributions-hsa-vs-irs', colors: [clrs.ChartContributionsVsIrsReportableColor, clrs.ChartContributionsVsIrsRemainingColor, clrs.ChartContributionsVsIrsExcessColor, clrs.ChartContributionsVsIrsContributionsLimitColor, clrs.ChartContributionsVsIrsCatchUpColor] },
        { name: 'contributions-year', colors: [clrs.ChartContributionsYourColor, clrs.ChartContributionsEmployerColor] },

        { name: 'expenses-year-to-date', colors: [clrs.ChartYearToDateSpendingReimbursedLightColor, clrs.ChartYearToDateSpendingPaidLightColor, clrs.ChartYearToDateSpendingRemainingLightColor, clrs.ChartYearToDateSpendingReimbursedColor, clrs.ChartYearToDateSpendingPaidColor, clrs.ChartYearToDateSpendingRemainingColor] },
        { name: 'expenses-total-responsibility', colors: [clrs.ChartTotalResponsibilityPaidColor, clrs.ChartTotalResponsibilityReimbursedColor, clrs.ChartTotalResponsibilityRemainingColor] },
        { name: 'investments-donut', colors: ["#c95c88", "#688aa4", "#66c794", "#eeef84", "#ecc465", "#b891c1", "#e4b7e3", "#92d9e4", "#ea9bba", "#94c0e2", "#96e8bd", "#b9ba5e", "#ec9465", "#886d8e", "#8f8691", "#ae0c4d", "#1d5077", "#1bab5f", "#e5e748", "#e2a719", "#955ba3", "#d794d5", "#5dc7d7", "#e06998", "#5fa1d4", "#62dc9c", "#96980e", "#e26019", "#4d2557", "#584b5b"] },

        { name: 'medical-claims-donut', count: 4, colors: [clrs.ChartFsaSpentLightColor, clrs.ChartFsaAvailableLightColor, clrs.ChartFsaSpentColor, clrs.ChartFsaAvailableColor] },
        { name: 'expenses-group-claims-donut', count: 6, colors: [clrs.ChartYearToDateSpendingReimbursedLightColor, clrs.ChartYearToDateSpendingPaidLightColor, clrs.ChartYearToDateSpendingRemainingLightColor, clrs.ChartYearToDateSpendingReimbursedColor, clrs.ChartYearToDateSpendingPaidColor, clrs.ChartYearToDateSpendingRemainingColor] }
    ]);

    // refresh chart
    function refreshChart(chartDiv) {
        var isVisible = chartDiv.is(':visible');
        var chartWidth = chartDiv.width();
        var chartHeight = chartDiv.height();

        function refreshCb() {
            var newIsVisible = chartDiv.is(':visible');
            if (!newIsVisible) {
                isVisible = newIsVisible;
                return;
            }
            var newChartWidth = chartDiv.width();
            var newChartHeight = chartDiv.height();
            if (newChartWidth === chartWidth && newChartHeight === chartHeight && newIsVisible === isVisible) {
                return;
            }
            chartWidth = newChartWidth;
            chartHeight = newChartHeight;
            isVisible = newIsVisible;
            chartDiv.jqxChart('refresh');
        }

        $(window).on('resize', _.debounce(refreshCb, 300));
        $(document).on('increased-font', function(){
            chartDiv.jqxChart('refresh');
        });
    }

    //add namespace for charts functions and vars
    $.extend(true, $, {
        cdh: {
            charts: {

                //donut chart
                bindDonutChart: function bindDonutChart(chartData, customOptions) {
                    try {
                        var chartDiv = $(chartData.element);
                        if (chartDiv.length == 0) return;

                        var options = {
                            display: {size: 130},
                        };
                        $.extend(true, options, customOptions);

                        if (options.display === 'fit') {
                            var fitSize = Math.min(chartDiv.width(), chartDiv.height()) / 2;
                            if (chartData.offsetX == undefined)
                                chartData.offsetX = fitSize;
                            options.display = { size: fitSize - 4 };
                        }
                        var data_source_desktop = {
                            datatype: "local",
                            datafields: [
                                { name: 'label' },
                                { name: 'value' }
                            ],
                            localdata: chartData.dataArr !== undefined ? chartData.dataArr.map(function(item) {
                                return { label: item.label, value: item.value === 0 ? null : item.value };
                            }) : []
                        };

                        var size = options.display.size;
                        var k = size / 130;
                        var dataAdapter_desktop = new $.jqx.dataAdapter(data_source_desktop, { async: false, autoBind: true });
                        // prepare jqxChart settings
                        var settings = chartData.settings != undefined ? chartData.settings : {
                            title: '',
                            description: '',
                            showLegend: false,
                            enableAnimations: true,
                            showBorderLine: false,
                            padding: { left: 0, top: 0, right: 0, bottom: 0 },
                            seriesGroups:
                                [
                                    {
                                        type: 'donut',
                                        offsetX: chartData.offsetX != undefined ? chartData.offsetX : 140,
                                        source: dataAdapter_desktop,
                                        colorScheme: chartData.colorScheme,
                                        useGradientColors: false,
                                        mouseover: changeFill,
                                        mouseout: changeFill,
                                        series: chartData.series != undefined ? chartData.series :
                                            [
                                                {
                                                    dataField: 'value',
                                                    displayText: 'label',
                                                    labelRadius: size - 20*k,
                                                    initialAngle: 90,
                                                    radius: size - 10*k,
                                                    innerRadius: size - 30*k,
                                                    centerOffset: 0,
                                                    formatSettings: { prefix: '$', decimalPlaces: 2 }
                                                },
                                                {
                                                    dataField: 'value',
                                                    displayText: 'label',
                                                    labelRadius: size - 20*k,
                                                    initialAngle: 90,
                                                    radius: size,
                                                    innerRadius: size - 20*k,
                                                    centerOffset: 0,
                                                    formatSettings: { prefix: '$', decimalPlaces: 2 }
                                                }
                                            ]
                                    }
                                ]
                        };

                        //Extend settings with extendSettings property (structure should be the same as jqxChart settings object)
                        if (chartData.extendSettings != undefined) {
                            $.extend(true, settings, chartData.extendSettings);
                        }

                        chartDiv.on('refreshEnd', function (e) {
                            makePattern();
                            setTimeout(function () {
                                changeFill();
                            }, 1000);
                        });                        

                        function makePattern() {
                            const $svg = $(chartDiv);
                            const $gTags = $svg.find('g');
                            $gTags.each(function (i, gTag) {
                                $gTag = $(gTag);
                                const $paths = $gTag.children('path');
                                if ($paths.length === 4) {
                                    $.cdh.helper.makePathPattern($paths[0], '1');
                                    $.cdh.helper.makePathPattern($paths[2], '1');

                                    $.cdh.helper.makePathPattern($paths[1], '0');
                                    $.cdh.helper.makePathPattern($paths[3], '0');
                                } else if ($paths.length === 2) {
                                    $.cdh.helper.makePathPattern($paths[0], '0');
                                    $.cdh.helper.makePathPattern($paths[1], '0');
                                } else if ($paths.length === 6) {
                                    $.cdh.helper.makePathPattern($paths[0], '2');
                                    $.cdh.helper.makePathPattern($paths[3], '2');

                                    $.cdh.helper.makePathPattern($paths[1], '1');
                                    $.cdh.helper.makePathPattern($paths[4], '1');

                                    $.cdh.helper.makePathPattern($paths[2], '0');
                                    $.cdh.helper.makePathPattern($paths[5], '0');
                                }
                            });
                        }

                        function changeFill() {
                            const items = chartDiv.find('[data-fill]');
                            items.each(function (i, el) {
                                const fill = el.getAttribute('data-fill');
                                el.setAttribute('fill', fill);
                            });
                        }

                        // setup the chart
                        chartDiv.jqxChart(settings);
                        setTimeout(function() {
                            $.cdh.helper.setChartAttrs(chartDiv);
                            chartDiv.on('refreshEnd', function (e) {
                                $.cdh.helper.setChartAttrs(chartDiv);
                            });
                        }, 200);

                        // refresh chart on windows resize
                        refreshChart(chartDiv);
                    } catch (err) {
                        //do nothing
                    }
                },

                //chart with stacked column series
                bindStackedColumnChart: function bindStackedColumnChart(chartData, callback) {
                    // for test charts
                    //chartData.dataArr[0].ContributionsYTD = 1;
                    //chartData.dataArr[0].RemainingContributions = 10;
                    try {
                        var chartDiv = $(chartData.element);
                        if (chartDiv.length == 0) return;

                        //Visibility of series label - if values diff is too much
                        var dataObj = chartData.dataArr != undefined && chartData.dataArr.length > 0 ? chartData.dataArr[0] : {};
                        var firstSerieLabelsVisible = dataObj.hasOwnProperty('ContributionsYTD') && Math.round(dataObj.ContributionsYTD / (dataObj.RemainingContributions || 0.001)) < 50;
                        var secondSerieLabelsVisible = dataObj.hasOwnProperty('RemainingContributions') && Math.round(dataObj.RemainingContributions / (dataObj.ContributionsYTD || 0.001)) < 50;
                        //labels for series
                        var labelsArr = chartData.labelsArr != undefined ? chartData.labelsArr : [$.cdh.languageConstant.getConstant('AccountDetail.lblPayrollDepositsYTD'), $.cdh.languageConstant.getConstant('AccountDetail.lblRemainingPayrollDeposits')];
                        // setup the chart
                        var data_source = chartData.dataArr != undefined ? chartData.dataArr : [];
                        // prepare jqxChart settings
                        var settings = chartData.settings != undefined ? chartData.settings : {
                            title: '',
                            description: '',
                            showLegend: false,
                            enableAnimations: true,
                            showBorderLine: false,
                            padding: chartData.padding != undefined ? chartData.padding : { left: 0, top: 20, right: 30, bottom: 10 },
                            source: data_source,
                            xAxis: chartData.xAxis != undefined ? chartData.xAxis : { visible: false },
                            valueAxis: chartData.valueAxis != undefined ? chartData.valueAxis : {
                                title: { text: '' },
                                unitInterval: dataObj.hasOwnProperty('RemainingContributions') ? (Math.abs(dataObj.RemainingContributions) + Math.abs(dataObj.ContributionsYTD)) / 4 || 1 : 1,
                                labels: { step: 1, horizontalAlignment: 'right', formatSettings: { prefix: '$', decimalPlaces: 2 } },
                                tickMarks: { color: '#eee' },
                                gridLines: { color: '#eee' }
                            },
                            colorScheme: chartData.colorScheme,
                            seriesGroups: chartData.seriesGroups != undefined ? chartData.seriesGroups : [{
                                type: 'stackedcolumn',
                                columnsMaxWidth: chartData.columnsMaxWidth != undefined ? chartData.columnsMaxWidth : 130,
                                columnsMinWidth: chartData.columnsMinWidth != undefined ? chartData.columnsMinWidth : 130,
                                useGradientColors: false,
                                mouseover: changeFill,
                                mouseout: changeFill,
                                series: chartData.series != undefined ? chartData.series :
                                    [
                                        {
                                            dataField: 'ContributionsYTD',
                                            displayText: labelsArr[0],
                                            opacity: '0.7',
                                            lineWidth: 0,
                                            formatSettings: { prefix: '$', decimalPlaces: 2 },
                                            //labels: { visible: secondSerieLabelsVisible, offset: { x: 0, y: 0 }, verticalAlignment: 'bottom', class: 'account-contribution-text' },
                                            toolTipFormatFunction: function (value, itemIndex, serieIndex, groupIndex) {
                                                return labelsArr[0] + ': $' + dataObj['ContributionsYTD'];
                                            }
                                        },
                                        {
                                            dataField: 'RemainingContributions',
                                            displayText: labelsArr[1],
                                            opacity: '0.7',
                                            lineWidth: 0,
                                            formatSettings: { prefix: '$', decimalPlaces: 2 },
                                            // labels: { visible: firstSerieLabelsVisible, offset: { x: 0, y: 0 }, verticalAlignment: 'top', class: 'account-contribution-text' },
                                            toolTipFormatFunction: function (value, itemIndex, serieIndex, groupIndex) {
                                                return labelsArr[1] + ': $' + dataObj['RemainingContributions'];
                                            }
                                        }
                                    ]
                            }]
                        };

                        //Extend settings with extendSettings property (structure should be the same as jqxChart settings object)
                        if (chartData.extendSettings != undefined) {
                            $.extend(true, settings, chartData.extendSettings);
                        }
                        
                        chartDiv.on('refreshEnd', function (e) {
                            makePattern();
                            setTimeout(function () {
                                changeFill();
                            }, 1000);
                        });                        
                        
                        function makePattern() {
                            const $svg = $(chartDiv);
                            const $gTags = $svg.find('g');
                            $gTags.each(function (i, gTag) {
                                $gTag = $(gTag);
                                const $paths = $gTag.children('rect');
                                if ($paths.length === 2) {
                                    if (settings.seriesGroups[0].type === 'stackedcolumn') {
                                        $.cdh.helper.makePathPattern($paths[0], '1');
                                        $.cdh.helper.makePathPattern($paths[1], '0');
                                    } else if (settings.seriesGroups[0].type === 'stackedcolumn100') {
                                        $.cdh.helper.makePathPattern($paths[0], '0');
                                        $.cdh.helper.makePathPattern($paths[1], '1');
                                    }
                                } else if ($paths.length !== 0 && $paths.length % 3 === 0) {
                                    if (settings.seriesGroups[0].type === 'stackedcolumn') {
                                        for (let i = 0; i <= $paths.length; i += 3) {
                                            $.cdh.helper.makePathPattern($paths[i], '1');
                                            $.cdh.helper.makePathPattern($paths[i + 1], '0');
                                            $.cdh.helper.makePathPattern($paths[i + 2], '2');
                                        }
                                    }                                    
                                } else if ($paths.length !== 0 && $paths.length % 5 === 0) {
                                    if (settings.seriesGroups[0].type === 'stackedcolumn') {
                                        for (let i = 0; i <= $paths.length; i += 5) {
                                            $.cdh.helper.makePathPattern($paths[i], '0');
                                            $.cdh.helper.makePathPattern($paths[i + 1], '1');
                                            $.cdh.helper.makePathPattern($paths[i + 2], '2');
                                            $.cdh.helper.makePathPattern($paths[i + 3], '3');
                                            $.cdh.helper.makePathPattern($paths[i + 4], '0');
                                        }
                                    }
                                }
                            });
                        }

                        function changeFill() {
                            const items = chartDiv.find('[data-fill]');
                            items.each(function (i, el) {
                                const fill = el.getAttribute('data-fill');
                                el.setAttribute('fill', fill);
                            });
                        }

                        // setup the chart
                        if (callback) {
                            chartDiv.on('refreshEnd', function(e) {
                                callback();
                            });
                        }
                        chartDiv.jqxChart(settings);
                        setTimeout(function() {
                            $.cdh.helper.setChartAttrs(chartDiv);
                            chartDiv.on('refreshEnd', function(e) {
                                $.cdh.helper.setChartAttrs(chartDiv);
                            });
                        }, 200);

                        // refresh chart on windows resize
                        refreshChart(chartDiv);
                    } catch (err) {
                        //do nothing
                    }
                },

                //chart with column series
                bindColumnChart: function bindColumnChart(chartData) {
                    try {
                        var chartDiv = $(chartData.element);
                        if (chartDiv.length == 0) return;

                        // setup the chart
                        var data_source = chartData.dataArr != undefined ? chartData.dataArr : [];
                        // prepare jqxChart settings
                        var settings = chartData.settings != undefined ? chartData.settings : {
                            title: '',
                            description: '',
                            showLegend: false,
                            enableAnimations: true,
                            showBorderLine: false,
                            padding: chartData.padding != undefined ? chartData.padding : { left: 0, top: 20, right: 30, bottom: 10 },
                            source: data_source,
                            xAxis: chartData.xAxis != undefined ? chartData.xAxis : {
                                dataField: 'Month',
                                showGridLines: false
                            },
                            valueAxis: chartData.valueAxis != undefined ? chartData.valueAxis : {
                                title: { text: '' },
                                unitInterval: 100,
                                labels: { step: 1, horizontalAlignment: 'right', formatSettings: { prefix: '$', decimalPlaces: 2 } },
                                tickMarks: { color: '#BCBCBC' }
                            },
                            colorScheme: chartData.colorScheme,
                            seriesGroups: chartData.seriesGroups != undefined ? chartData.seriesGroups : [{
                                type: 'column',
                                columnsGapPercent: 50,
                                seriesGapPercent: 0,
                                useGradientColors: false,
                                series: chartData.series != undefined ? chartData.series :
                                    [
                                        {
                                            dataField: 'spent',
                                            displayText: $.cdh.languageConstant.getConstant('AccountDetail.lblSpent'),
                                            formatSettings: { prefix: '$', decimalPlaces: 2 }
                                        },
                                        {
                                            dataField: 'contributions',
                                            displayText: $.cdh.languageConstant.getConstant('AccountDetail.lblContribution'),
                                            formatSettings: { prefix: '$', decimalPlaces: 2 }
                                        }
                                    ]
                            }]
                        };
                        //Extend settings with extendSettings property (structure should be the same as jqxChart settings object)
                        if (chartData.extendSettings != undefined) {
                            $.extend(true, settings, chartData.extendSettings);
                        }
                        // setup the chart
                        chartDiv.jqxChart(settings);

                        // refresh chart on windows resize
                        refreshChart(chartDiv);
                    } catch (err) {
                        //do nothing
                    }
                }

            }
        }
    });

    // chart tooltips
    (function () {
        function closeTooltips() {
            const tooltips = document.querySelectorAll('div.jqx-rc-all.contentDiv');
            if (!tooltips.length) {
                return;
            }
            for (let i = 0; i < tooltips.length; i++) {
                const tooltip = tooltips[i].parentNode;
                if (!tooltip) {
                    return;
                }
                if (tooltip.tagName.toLowerCase() === 'div' &&
                    tooltip.style.position === 'absolute' &&
                    tooltip.style.display !== 'none') {
                    tooltip.style.display = 'none';
                }
            }
        }
        window.addEventListener('keydown', function (e) {
            if (e.keyCode === 27) {
                closeTooltips();
            }
        });
    }()); // chart tooltips

})(jQuery);